export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/12074548/pexels-photo-12074548.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "Coats",
    category: "coats",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/398078/pexels-photo-398078.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Jeans",
    category: "jeans",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/609771/pexels-photo-609771.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Shoes",
    category: "sheos",
  },
];
export const products = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/840916/pexels-photo-840916.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "Mens Light Brown Coat",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vel lorem rutrum felis viverra venenatis non ut dui. Morbi pellentesque varius nisi ut dignissim. Nunc nec tincidunt neque. Integer non quam dui. Nulla iaculis odio in eros vulputate, sit amet bibendum eros bibendum. Donec pharetra laoreet ligula nec laoreet. Duis placerat augue at interdum euismod. In tincidunt erat quis ante pretium tempus. Cras condimentum tellus nec elit scelerisque, vel convallis magna luctus. Ut vulputate nec turpis eget tincidunt.",
    category: ["coats", "man"],
    size: ["S", "M", "L", "XL"],
    color: ["brown"],
    price: 150.0,
    featured: true,
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/4427874/pexels-photo-4427874.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Woman Light Brown Coat",
    description:
      "Curabitur sollicitudin libero lacus, quis ultrices diam vehicula eget. Nulla ac consectetur nisl, vitae fringilla sem. Sed dapibus commodo ex, vitae volutpat ligula iaculis a. Nulla hendrerit libero eros. Nam odio augue, imperdiet non augue sed, tempus imperdiet libero. Fusce sed diam sollicitudin leo efficitur sodales ullamcorper in erat. Quisque viverra nibh elit, eget ultricies elit laoreet quis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Curabitur a risus viverra, semper nulla ac, sagittis nulla. Nulla faucibus metus in blandit auctor.",
    category: ["coats", "woman"],
    size: ["XS", "S", "M", "L"],
    color: ["brown"],
    price: 130.0,
    featured: false,
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/10204769/pexels-photo-10204769.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Men Ripped Blue Jeans",
    description:
      "Praesent tincidunt ullamcorper turpis, tempor consectetur purus lobortis in. Suspendisse euismod vehicula luctus. Maecenas dictum enim vitae tempus venenatis. Nullam posuere nec augue quis convallis. Vivamus auctor aliquet nibh, a dapibus odio finibus eget. Aliquam eu turpis maximus, porttitor metus at, iaculis ligula. In hac habitasse platea dictumst. Ut lacus metus, blandit eget mollis ac, tempus sit amet ipsum. Quisque scelerisque odio at elit molestie sodales. Vivamus eget nunc mauris. Nam consequat at arcu et iaculis. Etiam tristique malesuada enim id suscipit. Fusce vitae dolor elementum, consectetur nulla et, iaculis diam. Praesent id lacus eget mauris scelerisque hendrerit et vitae mauris. Mauris a arcu ante. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    category: ["jeans", "man"],
    size: ["S", "M", "L"],
    color: ["blue"],
    price: 45.0,
    featured: false,
  },
  {
    id: 4,
    img: "https://images.pexels.com/photos/2343661/pexels-photo-2343661.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Woman Blue Jeans",
    description:
      "Nulla pulvinar est sit amet enim feugiat rhoncus. Nullam maximus in est in eleifend. In mi eros, molestie vitae odio ut, rutrum congue sapien. Nunc augue orci, dictum dapibus vulputate a, luctus nec augue. Sed est ligula, vestibulum id dui sit amet, vehicula dapibus ipsum. Sed gravida nibh at tellus ultrices pellentesque. Nulla lectus justo, volutpat vel vulputate et, efficitur a metus. Duis vel tristique augue. Pellentesque lorem dui, iaculis vel dictum vitae, dictum tincidunt purus. Donec ante risus, condimentum vel felis in, maximus finibus enim. Vivamus id interdum turpis, ac accumsan erat. Pellentesque vel lacus magna. Nunc commodo neque sed tellus consequat blandit.",
    category: ["jeans", "woman"],
    size: ["XS", "S", "M"],
    color: ["blue"],
    price: 60.0,
    featured: false,
  },
  {
    id: 5,
    img: "https://images.pexels.com/photos/6311262/pexels-photo-6311262.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Men Black Jeans",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ornare, eros nec ullamcorper luctus, ligula arcu bibendum leo, auctor aliquet tortor purus id erat. Morbi volutpat nibh quis lobortis vulputate. Ut ligula magna, tincidunt nec mauris ac, sollicitudin fermentum felis. Duis et velit convallis, dignissim leo nec, condimentum dui. Duis id iaculis mauris. Etiam et augue eu urna varius pretium. Ut porttitor, leo sed faucibus scelerisque, eros erat gravida turpis, sit amet eleifend erat felis at sapien. Praesent eget feugiat metus. Nulla tempus tellus sed blandit tempus. Praesent a rhoncus elit. Pellentesque vel nisl lacinia, fermentum urna nec, volutpat quam. Nam euismod ex sit amet urna pellentesque commodo. In turpis lacus, malesuada et felis mollis, ornare ullamcorper mauris. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Fusce massa ex, pellentesque id volutpat ac, hendrerit a urna. Fusce vehicula felis a lacus interdum, et mollis sapien iaculis.",
    category: ["jeans", "man"],
    size: ["S", "M", "L"],
    color: ["black"],
    price: 75.0,
    featured: true,
  },
  {
    id: 6,
    img: "https://images.pexels.com/photos/4271579/pexels-photo-4271579.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "Black Convers",
    description:
      "Suspendisse est ex, sollicitudin at egestas at, tincidunt et sapien. Cras eu ultricies nisi. Etiam et tellus est. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Nam a lacinia leo. Quisque quis augue lobortis, condimentum purus vitae, malesuada ipsum. Ut consectetur est et ex ultricies, ut hendrerit quam sodales. Morbi ut volutpat ex, quis interdum purus. Nunc pharetra convallis diam, a malesuada ligula finibus in. Praesent vel mauris vitae nisl aliquet aliquet. Maecenas aliquam metus lectus, nec volutpat urna interdum sed. Vestibulum in ipsum in lorem lacinia pellentesque ac sed dolor. In pretium, neque eu rhoncus porta, ligula est sodales libero, in iaculis nunc lectus sed sapien. Ut dapibus aliquam lorem, a lacinia massa tempus ut.",
    category: ["sheos", "man", "woman"],
    size: [6, 7, 8, 9, 10, 11],
    color: ["black", "white"],
    price: 85.0,
    featured: false,
  },
  {
    id: 7,
    img: "https://images.pexels.com/photos/1159670/pexels-photo-1159670.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Yellow Dr Martens",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Alias cum maxime quibusdam deserunt ut veniam in iste hic doloribus reprehenderit voluptate earum modi velit autem unde nihil dolor nisi quo, temporibus tempora quam animi officia. Officiis fugit maiores eaque repellendus error in, suscipit quas ipsam nisi tenetur nemo nulla non?",
    category: ["sheos", "man", "woman"],
    size: [6, 7, 8, 9, 10, 11],
    color: ["yellow", "black"],
    price: 125.0,
    featured: true,
  },
  {
    id: 8,
    img: "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Unisex Sneakers",
    description:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quisquam commodi iusto explicabo accusantium quod iure aliquid ratione sint praesentium debitis libero voluptatem corporis inventore, iste nisi, itaque quae aperiam consequuntur minus ipsa nam? Optio perspiciatis ullam hic numquam. Pariatur quisquam laborum ab eveniet dolorem. Minus aperiam, vero sequi dolor reprehenderit ab error unde aut consectetur qui doloremque distinctio expedita, debitis omnis molestiae modi corporis cum, vel velit! Odit, perferendis eligendi!",
    category: ["sheos", "man", "woman"],
    size: [6, 7, 8, 9, 10, 11],
    color: ["gray", "white", "yellow", "pink", "black"],
    price: 85.0,
    featured: true,
  },
  {
    id: 9,
    img: "https://images.pexels.com/photos/19090/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=750&w=1260",
    title: "Casual Blue Sheos",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta, excepturi! Assumenda nihil iusto numquam deleniti? Doloribus, ad in? Quam similique magnam pariatur aliquid tempore consequatur adipisci, earum voluptatem ipsum! Amet vero a minima magnam labore dolores autem nobis illum sunt facilis obcaecati quaerat iure nemo doloribus harum laborum porro aut officia dolor eum sapiente, cumque animi tenetur. Dolor, expedita corrupti modi odio, voluptatibus earum animi in exercitationem corporis odit accusamus.",
    category: ["sheos", "man", "woman"],
    size: [6, 7, 8, 9, 10, 11],
    color: ["blue", "white"],
    price: 45.0,
    featured: false,
  },
];
